import React from 'react';
import { Alert, Box, Button } from '@mui/material';

import { usePatientIntakeStatusContext } from '../../hooks';
import { useActionPromptContext } from './ActionPromptContext.tsx';

export const StepDisabledBanner = () => {
  const { onToggleDisabled, isDisabled } = useActionPromptContext();
  const { isHealthcareProvider } = usePatientIntakeStatusContext();

  const handleEnable = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    onToggleDisabled?.();
  };

  if (!isDisabled || !isHealthcareProvider) {
    return null;
  }

  return (
    <Alert
      icon={false}
      action={
        <Button size="small" onClick={handleEnable}>
          Enable
        </Button>
      }
      slotProps={{
        action: {
          sx: {
            p: 0,
            my: 'auto',
          },
        },
      }}
      severity="info"
      sx={{
        mx: 1,
        my: 1,
        px: 1,
        py: 0,
      }}
    >
      <Box display="inline-block">
        This step is currently disabled for the patient.{' '}
        <Box display={{ xs: 'none', sm: 'inline-block' }}>
          This means that the patient cannot see it or interact with it.
        </Box>
      </Box>
    </Alert>
  );
};
